var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da0000;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements",
    "data-name": "Graphic Elements"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.5,
    cy: 67.5,
    r: 67.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.62,45.84a11.3,11.3,0,0,0-8-8C95.64,36,67.5,36,67.5,36s-28.14,0-35.16,1.88a11.3,11.3,0,0,0-8,8c-1.88,7-1.88,21.66-1.88,21.66s0,14.64,1.88,21.66a11.3,11.3,0,0,0,8,8C39.36,99,67.5,99,67.5,99s28.14,0,35.16-1.88a11.3,11.3,0,0,0,8-8c1.88-7,1.88-21.66,1.88-21.66S112.5,52.86,110.62,45.84ZM58.5,81V54L81.88,67.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/YT.943130b0a2312244654d1ffa378ec30c.svg";
export { ForwardRef as ReactComponent };